let Base64 = require('js-base64').Base64;

let gameTypes = [
    {name:'ML',coin:'Diamond'},   // = 1, //无尽对决-沐瞳
    {name:'FF',coin:'Diamond'},   // = 2, //FreeFire-吃鸡
    {name:'RB',coin:'Robux'},   // = 3, //Roblox-VR
    {name:'LOL',coin:'Riot Point'},  // = 4, //英雄联盟
    {name:'PM',coin:'UC'},   // = 5, //绝地求生-PUBG MOBILE
    {name:'BS',coin:'Gems'},   // = 6, //荒野乱斗-Brawl Stars
    {name:'LM',coin:'Diamond'},   // = 7, //Lords Mobile:Tower Defense
    {name:'CC',coin:'Gems'},   // = 8, //Clash of Clans
    {name:'CD',coin:'CP'},   // = 9, //Call of Duty: Mobile - Elite of the Elite
];

export function UrlSearch() {
    let data = getRequest();
    if (data === null) {
        console.error("url null")
        return null;
    }

    if (data === 'undefined') {
        console.error("url undefined")
        return null;
    }
    try {
        //增加的业务逻辑  ======== begin ========
        let ct = data['ct'];
        let cts = [];
        if (typeof ct === 'string' && ct.length > 0) {
            let spm = ct.split('spm=');
            if (spm.length > 1) {
                try {
                    cts = Base64.decode(decodeURIComponent(spm[1])).split("#");
                } catch (e) {
                    console.error('No Ct');
                }
            }
        }
        if (cts.length > 0) {
            data['cts'] = cts;
            let type = JSON.parse(cts[0])[0];
            data['type'] = type;
            let game = gameTypes[type - 1];
            data['typeName'] = game.name;
            data['typeCoin'] = game.coin;

            data['active_count'] = cts[1];
        }else{
            let h5_params = data['h5_params'];
            if (typeof h5_params === 'string' && h5_params.length > 0) {
                let h5ParamsObj = JSON.parse(h5_params);
                let objType = typeof h5ParamsObj;
                if (objType === 'object') {
                    if (typeof h5ParamsObj['games'] === 'string') {
                        let games = JSON.parse(h5ParamsObj['games']);
                        data['gameList'] = games;
                        let type = games[0];
                        data['type'] = type;
                        let game = gameTypes[type - 1];
                        data['typeName'] = game.name;
                        data['typeCoin'] = game.coin;
                    }
                    if (typeof h5ParamsObj['active_count'] !== 'undefined') {
                        data['active_count'] = h5ParamsObj['active_count']+"";
                    }
                }
            }
        }


        //增加的业务逻辑  ======== end ========

        return data;
    } catch (e) {
        console.log(data)
        console.error('JsonStr To Json err');
        return null;
    }
}

function getRequest() {
    let urlStr = decodeURI(window.location.href);
    let url = urlStr.split("?")[1];//获取地址 "?" 后的配置
    if (typeof url === 'undefined') {
        return null;
    }
    let Request = {};
    let isNewUrl = url.substring(0, 5).indexOf('base=') !== -1;
    if (isNewUrl) {
        let strList = url.split("&");
        for (let i = 0; i < strList.length; i++) {
            let name = strList[i].split("=")[0];
            let val = strList[i].split("=")[1];
            if (name !== 'undefined') {
                Request[name] = val;
                if (name === 'base') {
                    let dataStr = val;
                    try {
                        dataStr = decodeURIComponent(dataStr);
                    } catch (e) {
                        console.error('decodeURIComponent 解析失败:' + dataStr);
                    }
                    try {
                        dataStr = Base64.decode(dataStr);
                    } catch (e) {
                        console.error('解析base64失败:' + dataStr);
                    }
                    try {
                        let toJson = JSON.parse(dataStr);
                        console.log(toJson)
                        for (const toKey in toJson) {
                            Request[toKey] = toJson[toKey];
                        }
                    } catch (e) {
                        console.error(dataStr);
                        console.error('str to json err');
                    }
                }
            }
        }
        return Request;
    } else {
        let dataStr = url;
        //移除异常内容
        dataStr = dataStr.replace('#/','');

        try {
            dataStr = decodeURIComponent(dataStr);
        } catch (e) {
            console.error('urlOld decodeURIComponent 解析失败:' + dataStr);
        }
        try {
            dataStr = Base64.decode(dataStr);
        } catch (e) {
            console.error('urlOld 解析base64失败:' + dataStr);
        }
        try {
            let toJson = JSON.parse(dataStr);
            for (const toKey in toJson) {
                Request[toKey] = toJson[toKey];
            }
        } catch (e) {
            console.error('urlOld: ' + dataStr);
            console.error('urlOld: str to json err');
            return null;
        }

        return Request;
    }
}
